import React from 'react';
const filters = ['New', 'In-contact', 'Negotiating', 'Confirmed', 'Closed'];
interface FilterPillsProps {
  activeFilter: string;
  onFilterChange: (filter: string) => void;
}
export function FilterPills({
  activeFilter,
  onFilterChange
}: FilterPillsProps) {
  return <div className="flex gap-3 overflow-x-auto px-4 py-4 no-scrollbar bg-neutral-bg" data-id="element-57">
      {filters.map((filter, index) => <button key={index} onClick={() => onFilterChange(filter)} className={`
            whitespace-nowrap px-4 py-1.5 rounded-lg text-sm font-medium transition-colors border
            ${activeFilter === filter ? 'bg-accent text-primary border-accent' : 'bg-white text-gray-600 border-gray-200 hover:border-gray-300'}
          `} data-id="element-58">
          {filter}
        </button>)}
    </div>;
}